export const featureToggles = {
  'Developer Features': false,
  'Use Advanced Search II': false,
  'Print Advanced Search Time': false,
  'Business Role Authorisation': false,
  'Use dev superset': false,
};

export type FeatureToggles = { [key in keyof typeof featureToggles]: boolean };
